import { ApiKey } from "@wingspanhq/wingspan-api-sdk";
import { useCallback } from "react";
import { useModalApiKeyForm } from "../modals/ModalApiKeyForm";
import { useModalApiKeySecret } from "../modals/ModalApiKeySecret";
import { useModalDeleteApiKey } from "../modals/ModalDeleteApiKey";
import { useModalRotateApiKey } from "../modals/ModalRotateApiKey";

export const useApiKeyActions = () => {
  const modalForm = useModalApiKeyForm();
  const modalSecret = useModalApiKeySecret();
  const modalDelete = useModalDeleteApiKey();
  const modalRotate = useModalRotateApiKey();

  const generate = useCallback(async () => {
    const created = await modalForm.open({});
    if (created) {
      await modalSecret.open({ apiKey: created });
    }
  }, [modalForm, modalSecret]);

  const edit = useCallback(
    (apiKey: ApiKey) => {
      modalForm.open({ apiKey });
    },
    [modalForm]
  );

  const rotate = useCallback(
    async (apiKey: ApiKey) => {
      const rotated = await modalRotate.open({ apiKey });
      if (rotated) {
        await modalSecret.open({ apiKey: rotated });
      }
    },
    [modalRotate, modalSecret]
  );

  const remove = useCallback(
    (apiKey: ApiKey) => {
      modalDelete.open({ apiKey });
    },
    [modalDelete]
  );

  return { generate, edit, rotate, remove };
};
